export const ContextSelectorStyles = {
  minWidth: 150,
  maxWidth: 350,
};